
var $ = require("jquery");

function getCookie(cname) {
    var name = cname + "=",
        ca = document.cookie.split(';'),
        i,
        c,
        ca_length = ca.length;
    for (i = 0; i < ca_length; i += 1) {
        c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) !== -1) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(variable, value, expires_seconds) {
    var d = new Date();
    if (expires_seconds) {
        d = new Date(d.getTime() + 1000 * expires_seconds);
        document.cookie = variable + '=' + value + '; Path=/;' + '; expires=' + d.toGMTString() + ';';
    } else {
        document.cookie = variable + '=' + value + '; Path=/;';
    }
}

function getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    return (results && results.length > 0) ? (results[1] || 0) : '';
}

function removeCookie(coockieName) {
    document.cookie = coockieName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function rememberParam(paramName, cookieName, existsCallback) {

    var val = getUrlParam(paramName) || '';
    if (val.length > 0) {
        setCookie(cookieName, val, 60 * 60 * 24 * 30); // 30 days

        if (existsCallback)
            existsCallback();
    }
}

function calculateLeadSource() {
    let utm_source = getCookie('utmsource') || '';
    let utm_medium = getCookie('utmmedium') || '';

    // google
    if (utm_source == 'google' && utm_medium == 'cpc')
        return 'Search: Google PPC';
    if (utm_source == 'google' && utm_medium == 'display')
        return 'Display: Google PPC';

    // bing
    if (utm_source == 'bing' && utm_medium == 'cpc')
        return 'Search: Bing PPC';
    if (utm_source == 'bing' && utm_medium == 'display')
        return 'Display: Bing PPC';

    // fb
    if (utm_source == 'facebook' && utm_medium == 'cpc')
        return 'Social: Facebook PPC';
    if (utm_source == 'facebook' && utm_medium == 'social-paid')
        return 'Social: Facebook PPC';
    if (utm_source == 'facebook' && utm_medium == 'social-boosted')
        return 'Social: Facebook Boosted';
    if (utm_source == 'facebook' && utm_medium == 'social-organic')
        return 'Social: Facebook Organic';

    // linkedin
    if (utm_source == 'linkedin' && utm_medium == 'social-organic')
        return 'Social: LinkedIn Organic';
    if (utm_source == 'linkedin' && utm_medium == 'social-paid')
        return 'Social: LinkedIn PPC';

    // yelp
    if (utm_source == 'yelp' && utm_medium == 'social-paid')
        return 'Social: Yelp PPC';
    if (utm_source == 'yelp' && utm_medium == 'social-organic')
        return 'Social: Yelp Organic';

    // other
    if (utm_source == 'youtube')
        return 'Social: YouTube PPC';

    if (utm_source == 'bom-programmatic' && utm_medium == 'display')
        return 'Display: Programmatic PPC';

    if (utm_source == 'programmatic' && utm_medium == 'display')
        return 'Display: Programmatic PPC';

    if (utm_source == 'pardot' && utm_medium == 'email')
        return 'Email';
    if (utm_source == 'newsletter' && utm_medium == 'email')
        return 'Email';
    if (utm_source == 'landing' && utm_medium == 'parked')
        return 'Parked Domain';

    if (utm_source == 'vanity-url')
        return 'Vanity URL';

    if (utm_source == 'vanity-url')
        return 'Vanity URL';

    if (utm_source == 'postcard')
        return 'Print: Postcard';

    if (utm_source == 'brochure')
        return 'Print: Brochure';


    // other 2.
    if ((getCookie('gclid') || '').length > 0)
        return 'Search: Google PPC';

    if ((getCookie('fbclid') || '').length > 0)
        return 'Social: Facebook PPC';

    if ((getCookie('msclkid') || '').length > 0)
        return 'Search: Bing PPC';


    let referrerUrl = '';
    {
        var watermark_referer_coockie = getCookie('watermark_referer') || '';

        if (watermark_referer_coockie.length > 0) {
            referrerUrl = new URL(watermark_referer_coockie).hostname;
        }
    }

    if (referrerUrl.indexOf('bing.com') > -1) return 'Search: Bing Organic';
    if (referrerUrl.indexOf('duckduckgo.com') > -1) return 'Search: DuckDuckGo Organic';
    if (referrerUrl.indexOf('google.com') > -1) return 'Search: Google Organic';
    if (referrerUrl.indexOf('yahoo.com') > -1) return 'Search: Yahoo Organic';
    if (referrerUrl.indexOf('baidu.com') > -1) return 'Search: Baidu Organic';
    if (referrerUrl.indexOf('facebook.com') > -1) return 'Social: Facebook Organic';
    if (referrerUrl.indexOf('instagram.com') > -1) return 'Social: Instagram Organic';
    if (referrerUrl.indexOf('linkedin.com') > -1) return 'Social: LinkedIn Organic';
    if (referrerUrl.indexOf('pinterest.com') > -1) return 'Social: Pinterest Organic';
    if (referrerUrl.indexOf('twitter.com') > -1) return 'Social: Twitter Organic';
    if (referrerUrl.indexOf('yelp.com') > -1) return 'Social: Yelp Organic';
    if (referrerUrl.indexOf('youtube.com') > -1) return 'Social: YouTube Organic';
    //case 'watermarkcommunities.com': return 'Watermark Website';

    if (referrerUrl.length == 0)
        return 'Direct Visit/Unknown';
    else
        return 'Other Website';

    return
}

export function rememberUtm() {

    // utms
    rememberParam('utm_campaign', 'utmcampaign');
    rememberParam('utm_medium', 'utmmedium');
    rememberParam('utm_source', 'utmsource');
    rememberParam('utm_content', 'utmcontent');
    rememberParam('utm_term', 'utmterm');

    // google
    rememberParam('gclid', 'gclid', function () {
        removeCookie('fbclid');
        removeCookie('msclkid');
    });

    // fb
    rememberParam('fbclid', 'fbclid', function () {
        removeCookie('gclid');
        removeCookie('msclkid');
    });

    // msc
    rememberParam('msclkid', 'msclkid', function () {
        removeCookie('fbclid');
        removeCookie('gclid');
    });

    // referer
    if ((window.WatermarkReferer || '').length > 0) {
        setCookie('watermark_referer', window.WatermarkReferer, 60 * 60 * 24 * 30); // 30 days
    }

    var leadSrcText = calculateLeadSource();
    var leadSrcTextCookie = getCookie('leadsrctext');
    if (leadSrcText && !leadSrcTextCookie) {
        setCookie('leadsrctext', leadSrcText); // Session.  No date/time
    }
}

